<template lang="html">
  <div v-if="taskEditLoading" class="centered">
    <loader />
  </div>
  <v-app v-else class="large-screen__body white">
    <v-toolbar dark tabs>
      <v-btn icon @click = "goBack">
        <img src="~icons/backIcon/backIcon.png" alt="backIcon">
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text pr-4">
        EDIT EFFORT
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div class="body">
      <!-- status bar -->
      <task-edit-status-bar :status="status" @change="setStatus"/>

      <v-container fluid grid-list-xl>
        <!-- title input -->
        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm2>
            <label for="Title">
              Title
              <sup class="red--text">*</sup>
            </label>
          </v-flex>
          <v-flex xs12 sm10>
            <input
              type="text"
              size="45"
              placeholder="Short title that explains the effort"
              v-model="taskName"
            />
          </v-flex>
          <character-count :text="taskName" :min="20"/>
        </v-layout>

        <!-- project search -->
        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm2>
            <label for="project">Project<sup class="red--text">*</sup></label>
          </v-flex>
          <v-flex xs12 sm10 class="pa-0">
            <project-search v-model="projectId" onlymine="1"></project-search>
          </v-flex>
        </v-layout>

        <!-- task organizer select -->
        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm2>
            <label for="project">Effort Organizers</label>
          </v-flex>
          <v-flex xs12 sm10 class="pa-0">
            <v-select
              multiple
              solo
              cache-items
              autocomplete
              return-object
              class="select"
              placeholder="Type to search for an effort organizer. You will be auto added."
              :search-input.sync="taskOrganizerInput"
              :items="users"
              item-text="username"
              item-value="user_id"
              v-model="tasksOrganizers"
              >
            </v-select>
          </v-flex>
        </v-layout>

        <!-- task description -->
        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm2 md2>
            <label for="Description">Description<sup class="red--text">*</sup></label>
          </v-flex>
          <v-flex xs12 sm10 md10>
            <textarea
              v-model="taskDescription"
              placeholder="Enter as much background information on this effort and its goal and scopes."
            ></textarea>
          </v-flex>
          <character-count :text="taskDescription" :min="50"/>
        </v-layout>

        <!-- organizer info -->
        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm2 md2>
            <label for="Description">Organizer Info</label>
          </v-flex>
          <v-flex xs12 sm10 md10>
            <textarea
              v-model="taskOrganizerDescription"
              placeholder="Enter information visible to all effort organizers"
            ></textarea>
          </v-flex>
        </v-layout>

        <!-- registered info -->
        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm2 md2>
            <label for="Description">Registered Info</label>
          </v-flex>
          <v-flex xs12 sm10 md10>
            <textarea
              v-model="taskRegisteredDescription"
              placeholder="Enter information visible to all users who register for the effort"
            ></textarea>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <!-- skills sector -->
          <v-flex xs12 md8>
            <v-layout row wrap class="input-container mb-2">
              <v-flex xs12 sm2>
                <label for="skills">Skills<sup class="red--text">*</sup></label>
              </v-flex>
              <!-- search-input: this is the data field which stores the typed input -->
              <!-- trigger the seaarch on this field chagnge -->
              <v-flex xs12 sm10 class="pa-0">
                <v-select
                  solo
                  multiple
                  cache-items
                  autocomplete
                  return-object
                  :search-input.sync="skillInput"
                  class="select"
                  placeholder="Type to search for skills"
                  :items="skills"
                  item-text="skill_name"
                  item-value="skill_id"
                  v-model="taskSkills"
                  >
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- effort length -->
          <v-flex xs12 md4>
            <v-layout row wrap class="input-container mb-2">
              <v-flex xs12 sm5>
                <label for="duration">Effort Length<sup class="red--text">*</sup></label>
              </v-flex>
              <v-flex xs12 sm7 class="pa-0">
                <v-select
                  flat
                  solo
                  class="select"
                  placeholder="Estimated effort required"
                  :items="durations.slice(1, durations.length)"
                  item-text="text"
                  item-value="value"
                  v-model="taskLength"
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- local or virtual -->
        <v-layout row wrap>
          <v-flex xs12 md6 class="pa-0 pt-2 pr-4">
            <v-btn-toggle mandatory v-model="taskVirtual">
              <v-btn icon value="1" title="Things that can be performed anywhere by anyone.">
                Virtual
              </v-btn>
              <v-btn icon value="0" title="Things that can be performed if you're within the location radius">
                Local
              </v-btn>
            </v-btn-toggle>
          </v-flex>

          <!-- completion type toggle -->
          <v-flex xs12 md6 class="pa-0 pt-2 pr-4">
            <v-btn-toggle mandatory v-model="completionType">
              <v-btn icon value="unique" title="Can be performed just Once per unique User, up to the total (optional) Completion Limit.">
                <i class="single-icon" v-if="completionType == 'unique'" ></i>
                <i class="single-icon-blue" v-else></i>
              </v-btn>
              <v-btn icon value="multi" title="Can be performed multiple times by any User, up to the total (optional) Completion Limit.">
                <i class="many-icon"v-if="completionType == 'multi'"></i>
                <i class="many-icon-blue" v-else></i>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>


        <v-layout row wrap>
          <!-- anonymous -->
          <v-flex xs12 md6 class="pa-0 pt-2 pr-4">
            <v-btn-toggle mandatory v-model="taskAnonymous">
              <v-btn icon value="1" title="Completion Questions could be answered by a anonymous users">
                Anonymous
              </v-btn>
              <v-btn icon value="0" title="Completion Questions could be answered only by registered users">
                Registered
              </v-btn>
            </v-btn-toggle>
          </v-flex>

          <!-- max completions -->
          <v-flex xs12 md6>
            <v-layout class="input-container mb-24" row wrap>
              <v-flex xs12 sm2 md7>
                <label for="Max completions">Max Completions</label>
              </v-flex>
              <v-flex xs12 sm8 md5>
                <input placeholder="(optional)" v-model.number="completionLimit"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- location checkbox -->
        <v-checkbox
          class="pt-3"
          label='Location restricted effort'
          v-model="locationRestricted"
        >
        </v-checkbox>
        <v-layout row wrap v-if="locationRestricted">
          <v-flex xs12 md9>
            <!-- location input -->
            <v-layout row wrap class="input-container mt-3">
              <v-flex xs12 sm2 md2>
                <label for="Location">Location</label>
              </v-flex>
              <v-flex xs12 sm10 md9>
                <vue-google-autocomplete
                    id="map"
                    classname="form-control"
                    placeholder="Start typing an address here."
                    @placechanged="onAddressChange"
                    :value="taskAddress"
                >
                </vue-google-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md3 class="location">
            <!-- radius selection -->
            <v-layout row wrap class="input-container  mt-3 mb-2">
              <v-flex xs4 sm2 md4>
                <label for="Radius">Radius</label>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs8 sm10 md8 class="pa-0">
                <v-select
                  flat
                  solo
                  class="select"
                  v-model="taskRadius"
                  placeholder="Select Radius"
                  :items="radius"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- time limits checkbox -->
        <v-checkbox
          class="pb-3"
          label='Time limits'
          v-model="timeLimited"
        >
        </v-checkbox>

        <v-layout row wrap v-if="timeLimited">
          <!-- Event Data -->
          <v-flex sm12 md5>
            <v-layout class="input-container mb-24" row wrap>
              <v-flex xs12 sm3>
                <label>Event Date</label>
              </v-flex>
              <v-flex xs12 sm9>
                  <datetime type="datetime" v-model="taskDateISOFormat">
                  </datetime>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex sm12 md5>
            <v-layout row wrap class="input-container mb-2">
              <v-flex xs12 sm3>
                <label for="duration">Duration</label>
              </v-flex>
              <v-flex xs12 sm9 class="pa-0">
                <v-select
                  flat
                  solo
                  class="select"
                  placeholder="Select duration for the effort"
                  :items="durations"
                  item-text="text"
                  item-value="value"
                  v-model="taskDuration"
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex sm12 md2>
            <span v-if="taskExpiry === 'NEVER'">expires {{ taskExpiry }}</span>
            <span v-else>expires on {{ taskExpiry }}</span>
          </v-flex>
        </v-layout>


        <!-- file upload -->
        <v-layout row wrap>
          <v-flex xs12 sm3 md2 class="pa-0 pr-4 pb-3">
            <v-btn class="upload" @click="onFilePick">Upload File</v-btn>
            <input
              @change="onFilePicked"
              type="file"
              accept="*/*"
              style="display: none;"
              ref="upload"
            >
          </v-flex>
          <div class="media-section">
            <v-layout row justify-center class="mb-2">
              <span class="pl-3"> or
                <v-btn
                  small
                  flat
                  :ripple="false"
                  @click.native.stop="dialog = true"
                >
                  add media from the web
                </v-btn>
              </span>
            </v-layout>
            <v-dialog v-model="dialog" max-width="736px" content-class="wrap-dialog">
              <v-card class="card web-media">
                <v-layout justify-center>
                  <div class="web-media-text mt-4 mb-2 mx-4">YouTube, Vimeo, and direct links to MOV and MPEG files will work.</div>
                </v-layout>
                <v-layout row wrap class="input-container mt-2 mb-4">
                  <v-flex xs12 sm12 md3>
                    <label for="Media">link</label>
                  </v-flex>
                  <v-flex xs12 sm12 md9>
                    <input
                      type="text"
                      placeholder="https:\\your-website.com"
                      v-model="url"
                      >
                     </input>
                  </v-flex>
                </v-layout>
                <v-layout justify-center>
                  <v-btn class="publish white--text mb-24" right round @click="addMediaUrl(url)">Add Link</v-btn>
                </v-layout>
              </v-card>
            </v-dialog>
          </div>
        </v-layout>
        <!-- image thumbnails -->
        <container @drop="sortMedia" orientation="horizontal" style="white-space: unset;">
          <draggable class="my-2" v-for="(image, index) in taskMedia" :key="image.data_object_id">
            <span @click="showGallery(index)" class="image-list">
              <imager :src="createThumbnailUrl(image.data_url)" :styles="{'min-width': '124px', 'max-height': '124px'}">
                <loader></loader>
              </imager>
              <v-btn icon class="image-list-button" @click.stop="removeTaskMediaObject(index)">
                <i class="delete-icon"></i>
              </v-btn>
            </span>
          </draggable>
        </container>

      </v-container>
      <v-divider></v-divider>

      <!-- Questionnaire section -->
      <div class="py-4">
        <p class="subheading center">Completion Questionaire</p>
      </div>

      <!-- Questionnaire hint banner -->
      <v-layout row wrap class="hidden" v-if="showHint">
        <v-flex xs10 sm11>
          <div class="white--text px-4 py-3">
            Questionnaire defines the way contributors will send you their reports about the completed effort.
          </div>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 sm1>
          <v-btn icon right @click="showHint = !showHint" class="mt-2">
            <i class="close-icon"></i>
          </v-btn>
        </v-flex>
      </v-layout>

      <!-- drag and drop instruction for Questionaire -->
      <v-layout>
        <v-flex xs12>
          <div class="caption py-3 mb-2 center gray--background">Drag’n’drop questions to change their order.</div>
        </v-flex>
      </v-layout>

      <v-container grid-list-xl>
        <container @drop="sortQuestions">
          <draggable column wrap v-for="(question, i) in taskQuestions" :key="question.task_completion_item_id" class="adddivider">
            <v-flex xs12 md12 lg12 xl12>
              <!-- question edit mode -->
              <template v-if="i===taskQuestionEditIndex">
                <v-layout row wrap class="input-container mt-3 mb-3">
                  <v-flex xs12 sm2>
                    <label for="Title">Question</label>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <textarea
                      type="text"
                      placeholder="Enter a description of the action or question the Contributor must complete."
                      :value="questionItemFieldByValue(i, 'task_completion_text')"
                      @change="(event) => { setQuestion({index:i, field: 'task_completion_text', value: event.target.value})}"
                    />
                  </v-flex>
                </v-layout>

                <!-- question type -->
                <v-layout>
                  <v-flex xs12 sm6>
                    <v-layout row wrap class="input-container mb-3">
                      <v-flex xs12 sm3>
                        <label for="project">Type</label>
                      </v-flex>
                      <v-flex xs12 sm9>
                        <v-select
                          class="select"
                          placeholder="Select question type"
                          :items="taskQuestionTypes"
                          item-text="completion_type_name"
                          item-value="task_completion_type_id"
                          :value="questionItemFieldByValue(i, 'task_completion_type_id')"
                          @change="(value) => { setQuestion({index:i, field: 'task_completion_type_id', value: value})}"
                        >
                      </v-select>
                    </v-flex>
                  </v-layout>
                  </v-flex>
                </v-layout>

                <!-- values of multiple type question -->
                <v-layout row wrap class="input-container mb-3" v-if="questionHasValueField(i)">
                  <v-flex xs12 sm2>
                    <label for="Title">Values</label>
                  </v-flex>
                  <v-flex xs12 sm10>
                    <input
                      type="text"
                      size="45"
                      placeholder="Please enter options separated by pipe |"
                      :value="questionItemFieldByValue(i, 'task_completion_elements')"
                      @change="(event) => { setQuestion({index:i, field: 'task_completion_elements', value: event.target.value})}"
                    />
                  </v-flex>
                </v-layout>
                <div v-if="isExistingQuestion">
                  <v-btn small flat :ripple="false" class="mb-2 edit" v-on:click="updateQuestion()"><div>Update Completion Question</div></v-btn>
                </div>
                <div v-else>
                  <v-btn small :ripple="false" class="mb-2 edit upload secondary-button" v-on:click="insertQuestion()"><div>Add Completion Question</div></v-btn>
                </div>
              </template>
              <!-- question view mode -->
              <template v-else>
                <v-layout row wrap>
                  <v-flex xs1 sm1>
                    {{ i + 1 }}
                  </v-flex>
                  <v-flex xs7 sm7 class="completion-question pr-3">
                    {{ taskQuestions[i]["task_completion_text"] && taskQuestions[i]["task_completion_text"].slice(0,255) }}
                    {{  taskQuestions[i]["task_completion_text"] && taskQuestions[i]["task_completion_text"].length >= 255 ? '...' : '' }}
                  </v-flex>
                  <v-flex xs1 sm2>
                  {{ taskCompletionTypeReadableName(taskQuestions[i]["task_completion_type_id"]) }}
                  </v-flex>
                  <v-flex xs3 sm2>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <v-btn small flat :ripple="false" class="edit mb-2" @click="editQuestion(i)"><div>Edit</div></v-btn>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <v-btn flat small :ripple="false" class="edit mb-2 " @click="removeQuestion(i)"><div>Delete</div></v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </template>
            </v-flex>
            <v-flex xs12 md12 lg12 v-if="!taskQuestions.length">
              <h4 class="no-questions-text">
                Please add at least one completion question before the effort can go live.
              </h4>
            </v-flex>
          </draggable>
        </container>
      </v-container>

      <!-- when this button is clicked insert a new item to the question list -->
      <!-- set the id of this item as editable -->
      <div>
        <v-btn v-if="taskQuestionEditIndex === null" @click="addQuestion({taskId})" class="edit mt-4 mb-2 secondary-button upload">
          <div>Add New Completion Question</div>
        </v-btn>
      </div>
    </div>
  </v-app>
</template>


<script>
import { find, get } from 'lodash';
import { mapActions } from 'vuex';
import moment from 'moment';

import { Container, Draggable } from 'vue-smooth-dnd';
import { applyDrag } from '@/utils/dnd';

import { Datetime } from 'vue-datetime';
import VueGoogleAutocomplete from 'vue-google-autocomplete';

import Imager from '@/components/Imager';
import Loader from '@/components/Loader';
import TaskEditStatusBar from '@/components/TaskEditStatusBar';
import ProjectSearch from '@/components/shared/ProjectSearch';
import CharacterCount from '@/components/shared/CharacterCount';

import uploader from '@/mixins/uploader';
import { identifyFileType, FILE_TYPES } from '@/utils/file_type';

// images
import audioThumbnail from 'icons/audio-thumbnail.png';
import videoThumbnail from 'icons/video-thumbnail.png';
import documentThumbnail from 'icons/document-thumbnail.png';

// import css
import 'vue-datetime/dist/vue-datetime.css';


export default {
  mixins: [uploader],
  components: {
    CharacterCount,
    VueGoogleAutocomplete,
    Datetime,
    Container,
    Draggable,
    Imager,
    Loader,
    ProjectSearch,
    TaskEditStatusBar,
  },
  data() {
    return {
      toggle_none: null,
      skillInput: null,
      taskOrganizerInput: null,
      dialog: false,
      url: null,
      radius: [
        { value: 1, text: '1km, 0.6mi' },
        { value: 2, text: '2km, 1.2mi' },
        { value: 3, text: '3km, 1.9mi' },
        { value: 8, text: '8km, 4.97mi' },
        { value: 20, text: '20km, 12.4mi' },
        { value: 50, text: '50km, 31mi' },
        { value: 96, text: '96km, 59.6mi' },
      ],
      durations: [
        { value: -1, text: 'Ongoing' },
        { value: 5, text: '5min' },
        { value: 10, text: '10min' },
        { value: 15, text: '15min' },
        { value: 30, text: '30min' },
        { value: 60, text: '1h' },
        { value: 120, text: '2h' },
        { value: 240, text: '4h' },
        { value: 480, text: '8h' },
        { value: 720, text: '12h' },
        { value: 1440, text: '24h' },
        { value: 60 * 24 * 7, text: '1 weeks' },
        { value: 60 * 24 * 7 * 2, text: '2 weeks' },
        { value: 60 * 24 * 7 * 3, text: '3 weeks' },
        { value: 60 * 24 * 7 * 4, text: '4 weeks' },
        { value: 60 * 24 * 7 * 4 * 2, text: '2 months' },
        { value: 60 * 24 * 7 * 4 * 6, text: '6 months' },
        { value: 60 * 24 * 7 * 4 * 12, text: '1 year' },
      ],
    };
  },
  methods: {
    ...mapActions({
      searchSkills: 'skills/searchSkills',
      searchUsers: 'users/searchUsers',
    }),
    addQuestion(options) {
      if (!this.paused) {
        this.$store.dispatch('auth/setFlashMessage', {
          message: 'Completion item can only be added when the effort is in a paused state',
          type: 'error',
        });
        return;
      }

      this.$store.dispatch('taskCompletion/addQuestion', options);
    },
    editQuestion(i) {
      if (!this.paused) {
        this.$store.dispatch('auth/setFlashMessage', {
          message: 'Completion item can only be edited when the effort is in a paused state',
          type: 'error',
        });
        return;
      }

      this.$store.dispatch('taskCompletion/editQuestion', i);
    },
    removeQuestion(i) {
      if (!this.paused) {
        this.$store.dispatch('auth/setFlashMessage', {
          message: 'Completion item can only be removed when the effort is in a paused state',
          type: 'error',
        });
        return;
      }

      this.$store.dispatch('taskCompletion/removeQuestion', i);
    },
    sortMedia({ removedIndex, addedIndex }) {
      this.taskMedia = applyDrag(this.taskMedia, removedIndex, addedIndex);
    },
    sortQuestions({ removedIndex, addedIndex }) {
      this.taskQuestions = applyDrag(this.taskQuestions, removedIndex, addedIndex);
    },
    goBack() {
      this.$router.go(-1);
    },
    setStatus(status) {
      if (status === '1') {
        // check required task name
        if (!this.taskName) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Effort should have a name before it can be published',
            type: 'error',
          });
          return;
        }

        if (this.taskName.length < 20) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Effort name should be at least 20 characters',
            type: 'error',
          });
          return;
        }

        // check required project
        if (!this.projectId) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Effort should belong to a project',
            type: 'error',
          });
          return;
        }

        // check required description
        if (!this.taskDescription) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Effort description is required before task can go live',
            type: 'error',
          });
          return;
        }

        if (this.taskDescription.length < 50) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Effort description should at least be 50 characters.',
            type: 'error',
          });
          return;
        }

        // check required task length
        if (!this.taskLength) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Effort length is required before you publish the task',
            type: 'error',
          });
          return;
        }

        // check required skills
        if (this.skills.length < 1) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Effort should ask for at least one skills before',
            type: 'error',
          });
          return;
        }

        // task questions
        if (this.taskQuestions.length === 0) {
          this.$store.dispatch('auth/setFlashMessage', {
            message: 'Effort should have at least one completion question to go live.',
            type: 'error',
          });
          return;
        }
      }


      this.status = status;
    },
    setQuestion(questionFields) {
      this.$store.dispatch('taskCompletion/setQuestion', questionFields);
    },
    questionItemFieldByValue(index, field) {
      // find the value of right field at given index in question list
      return this.taskQuestions[index][field];
    },
    questionHasValueField(index) {
      // finds out if 3rd input(values) is applicable or not
      const questionType = this.taskQuestions[index].task_completion_type_id;
      return ['2', '6', '8'].includes(questionType);
    },
    validateQuestionInsertOrUpdate() {
      // check if the question being edited/inserted is valid.
      // set flash if not valid
      // return the validitiy status

      let valid = true;
      const index = this.taskQuestionEditIndex;
      const hasValueField = this.questionHasValueField(index);

      if (!hasValueField) return valid;

      const question = this.taskQuestions[this.taskQuestionEditIndex];
      const type = question.task_completion_type_id;
      const options = question.task_completion_elements.split('|');

      if (type === '8' || type === 8) {
        valid = valid && options.length === 2;
        this.$store.dispatch('auth/setFlashMessage', {
          message: 'This question should have exactly two values',
          type: 'error',
        });
        return valid;
      }

      for (let i = 0; i < options.length; i += 1) {
        valid = valid && options[i].length > 0;
        this.$store.dispatch('auth/setFlashMessage', {
          message: 'This question cannot have any empty value.',
          type: 'error',
        });
      }

      return valid;
    },
    updateQuestion() {
      const valid = this.validateQuestionInsertOrUpdate();
      if (!valid) {
        return;
      }
      this.$store.dispatch('taskCompletion/updateQuestion');
    },
    insertQuestion() {
      const valid = this.validateQuestionInsertOrUpdate();
      if (!valid) {
        return;
      }
      this.$store.dispatch('taskCompletion/insertQuestion');
    },
    taskCompletionTypeReadableName(completionTypeId) {
      const questionType = find(
        this.taskQuestionTypes,
        qt => qt.task_completion_type_id === completionTypeId,
      );
      return get(questionType, 'completion_type_name');
    },
    onAddressChange(_, placeDataObject) {
      this.taskAddress = placeDataObject.formatted_address;
    },
    onFilePick() {
      this.$refs.upload.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      const file = files[0];
      // TODO: what to do while the image is loading
      // upload function is present in the upload mixin
      this.uploadMedia(file, { task_id: this.taskId })
        .then((mediaObject) => {
          this.addTaskMediaObject(mediaObject);
        });
    },
    showGallery(index) {
      this.$store.dispatch('gallery/showGallery', { show: true, active: index });
    },
    createOrUpdateTask(task) {
      this.$store.dispatch('tasks/editTask', {
        ...task,
        task_id: this.taskId,
      });
    },
    addMediaUrl(url) {
      if (!url) {
        return;
      }
      this.$store.dispatch('tasks/addMediaUrl', { tasks_data: [{ data_url: url }], task_id: this.taskId });
      this.url = ''; // to make the url field empty
      this.dialog = !this.dialog;
    },
    addTaskMediaObject(mediaObject) {
      // add the new media to the list of media
      this.$store.dispatch('tasks/tasksObjectAdd', mediaObject);
    },
    removeTaskMediaObject(index) {
      // TODO: remove the task object from the backend
      // remove the task media from the list
      this.$store.dispatch('tasks/tasksObjectRemove', {
        index,
        taskId: this.taskId,
      });
    },
    addTaskDate() {
      // adds a new object ot the task_dates if it doesn't exist already
      this.$store.dispatch('tasks/addTaskDate');
    },
    createThumbnailUrl(url) {
      /* eslint global-require: "warn" */
      const fileType = identifyFileType(url);
      switch (fileType) {
        case FILE_TYPES.IMAGE:
          return url;
        case FILE_TYPES.VIDEO:
          return videoThumbnail;
        case FILE_TYPES.AUDIO:
          return audioThumbnail;
        default:
          return documentThumbnail;
      }
    },
  },
  computed: {
    paused() {
      return this.status === 0;
    },
    taskEditLoading() {
      return this.$store.getters['tasks/taskEditLoading'];
    },
    timeLimited: {
      get() {
        return this.$store.getters['tasks/timeLimited'];
      },
      set(value) {
        if (value === true) {
          this.addTaskDate();
        } else {
          // update the tasks_dates to be empty
          this.$store.dispatch('tasks/editDates', { tasks_dates: [], task_id: this.taskId });
        }
      },
    },
    projects() {
      const projects = this.$store.getters['projects/list'];
      for (let i = 0; i < projects.length; i += 1) {
        if (projects[i].project_name === null) {
          projects[i].project_name = '';
        }
      }
      return [{ project_id: 'add_new_project', project_name: 'Add New Project' }, ...projects];
    },
    task() {
      return this.$store.getters['tasks/task'];
    },
    isExistingQuestion() {
      return this.$store.getters['taskCompletion/isExistingQuestion'];
    },
    skills() {
      return [
        ...this.taskSkills,
        ...this.$store.getters['skills/list'],
      ];
    },
    users() {
      return [
        ...this.tasksOrganizers,
        ...this.$store.getters['users/list'],
      ];
    },
    showHint: {
      get() { return this.$store.getters['tasks/showHint']; },
      set(value) { this.$store.dispatch('tasks/hintToggle', value); },
    },
    status: {
      get() {
        return parseInt(this.$store.getters['tasks/taskStatus'], 10);
      },
      set(value) { this.createOrUpdateTask({ task_status: value }); },
    },
    taskName: {
      get() { return this.task.task_name; },
      set(value) { this.createOrUpdateTask({ task_name: value }); },
    },
    projectId: {
      get() { return this.task.project_id; },
      set(value) {
        this.createOrUpdateTask({ project_id: value });
      },
    },
    completionType: {
      get() { return this.task.completion_type; },
      set(value) { this.createOrUpdateTask({ completion_type: value }); },
    },
    completionLimit: {
      get() { return this.task.completion_limit; },
      set(value) { this.createOrUpdateTask({ completion_limit: value }); },
    },
    taskVirtual: {
      get() { return this.task.task_virtual; },
      set(value) { this.createOrUpdateTask({ task_virtual: value }); },
    },
    taskAnonymous: {
      get() { return this.task.task_allow_anon; },
      set(value) { this.createOrUpdateTask({ task_allow_anon: value }); },
    },
    taskDescription: {
      get() { return this.task.task_description; },
      set(value) { this.createOrUpdateTask({ task_description: value }); },
    },
    taskOrganizerDescription: {
      get() { return this.task.task_organizer_description; },
      set(value) { this.createOrUpdateTask({ task_organizer_description: value }); },
    },
    taskRegisteredDescription: {
      get() { return this.task.task_registered_description; },
      set(value) { this.createOrUpdateTask({ task_registered_description: value }); },
    },
    locationRestricted: {
      get() {
        return this.task.task_location_restricted === '1';
      },
      set(value) {
        if (value === false) {
          this.$store.dispatch('tasks/editLocations', { tasks_locations: [], task_id: this.taskId });
        }
        this.createOrUpdateTask({ task_location_restricted: value === true ? '1' : '0' });
      },
    },
    taskAddress: {
      // NOTE: returning just the first location, when we enable multiple location
      // enable them to send the location
      get() {
        const address = this.$store.getters['tasks/taskAddress'] || [];
        return address || {};
      },
      set(value) {
        this.$store.dispatch('tasks/editLocations', { tasks_locations: [{ location_address: value, task_radius: this.taskRadius }], task_id: this.taskId });
      },
    },
    taskRadius: {
      get() { return parseInt(this.$store.getters['tasks/taskRadius'], 10); },
      set(value) {
        this.$store.dispatch('tasks/editLocations', { tasks_locations: [{ location_address: this.taskAddress, task_radius: value }], task_id: this.taskId });
      },
    },
    tasksOrganizers: {
      get() { return this.$store.getters['tasks/organizers']; },
      set(value) { this.$store.dispatch('tasks/editOrganizers', { task_id: this.taskId, tasks_organizers: value }); },
    },
    taskSkills: {
      get() { return this.$store.getters['tasks/skills']; },
      set(value) { this.$store.dispatch('tasks/editSkills', { task_id: this.taskId, tasks_skills: value }); },
    },
    taskExpiry() {
      if (!this.taskDate || !this.taskDuration) {
        return 'NA';
      }
      if (this.taskDate && this.taskDuration === -1) {
        return 'NEVER';
      }
      const minutes = parseInt(this.taskDuration, 10);
      return moment(this.taskDate).add(minutes, 'minutes').format('DD/MM/YY hh:mm a');
    },
    taskId() {
      return this.$route.params.id;
    },
    taskDateISOFormat: {
      get() {
        const date = this.taskDate;
        const isoDate = `${moment(date, 'YYYY-MM-DD hh:mm:ss').format(moment.HTML5_FMT.DATETIME_LOCAL_MS)}Z`;
        return isoDate;
      },
      set(value) {
        this.taskDate = value;
      },
    },
    taskDate: {
      get() {
        const date = this.$store.getters['tasks/taskDate'];
        if (!date) {
          return null;
        }
        return date;
      },
      set(value) {
        if (!value) {
          return;
        }
        // parse the date into the right format
        const date = moment(value).utc().format('YYYY-MM-DD hh:mm:ss');
        // handle duration to be not sent as -1
        if (date === this.taskDate) {
          // will handle the problem with date picker
          return;
        }
        let taskDuration = this.taskDuration;
        if (taskDuration === -1) {
          taskDuration = null;
        }

        this.$store.dispatch('tasks/editDates', { tasks_dates: [{ task_date: date, task_duration: taskDuration }], task_id: this.taskId });
      },
    },
    taskLength: {
      get() {
        const taskLength = this.task.task_length;
        return parseInt(taskLength, 10);
      },
      set(value) {
        const taskLength = parseInt(value, 10);
        this.createOrUpdateTask({ task_length: taskLength });
      },
    },
    taskDuration: {
      get() {
        let taskDuration = this.$store.getters['tasks/taskDuration'];
        if (!taskDuration) {
          taskDuration = -1;
        }
        // parseInt used to convert it to int as values used is in int
        return parseInt(taskDuration, 10);
      },
      set(value) {
        // handling value of ongoing
        // the backend expects the duration to be not set in case of ongoing
        let taskDuration = parseInt(value, 10);
        if (taskDuration === -1) {
          taskDuration = null;
        }
        this.$store.dispatch('tasks/editDates', { tasks_dates: [{ task_date: this.taskDate, task_duration: taskDuration }], task_id: this.taskId });
      },
    },
    taskTags: {
      get() { return this.task.task_tags; },
      set(value) { this.createOrUpdateTask({ task_tags: value }); },
    },
    taskQuestions: {
      get() { return this.$store.getters['taskCompletion/list']; },
      set(taskCompletionItems) {
        if (this.status !== 0) {
          return;
        }
        this.$store.dispatch('taskCompletion/resortQuestion', { taskCompletionItems, taskId: this.taskId });
      },
    },
    taskQuestionTypes() {
      return this.$store.getters['taskCompletion/types'];
    },
    taskQuestionEditIndex() {
      return this.$store.getters['taskCompletion/editingIndex'];
    },
    taskMedia: {
      get() {
        const images = this.$store.getters['tasks/taskObjects'];
        const imageUrls = [];
        for (let i = 0; i < images.length; i += 1) {
          imageUrls.push(images[i].data_url);
        }
        this.$store.dispatch('gallery/setImages', imageUrls);
        return images;
      },
      set(taskMediaObjects) { this.$store.dispatch('tasks/reorderTaskMedia', { taskMediaObjects, taskId: this.taskId }); },
    },
  },
  watch: {
    skillInput(val) {
      if (val && val.length >= 3) {
        this.searchSkills(val);
      }
    },
    taskOrganizerInput(val) {
      if (val && val.length >= 3) {
        this.searchUsers(val);
      }
    },
  },
  mounted() {
    this.$store.dispatch('tasks/resetTasksState');
    const taskId = this.taskId;
    // load all the projects
    this.$store.dispatch('projects/getProjectList');
    // load the skills
    // load all the task question types
    this.$store.dispatch('taskCompletion/getTaskCompletionQuestionTypes');
    // load all the tasks questions for the given task
    this.$store.dispatch('taskCompletion/getTaskCompletionQuestionList', taskId);
    // should dispatach action editTaskDetails with the task id
    this.$store.dispatch('tasks/getTaskEditDetails', taskId);
    // load the task defaults
    this.$store.dispatch('tasks/getTaskEditDefaults');
  },
};
</script>

<style lang="scss" scoped>

@import "~styles/shared.scss";

#app {
  input {
    width:100%;
    font-size:16px;
  }
  .cursor-disabled {
    cursor: not-allowed;
  }
  .hidden {
    background: linear-gradient(to right, #ffd677, #ff2e64);
    text-align: center;
  }
  ::placeholder {
    font-size: 16px;
    color: $placeholder;
  }

  .adddivider {
    border-bottom: 0.5px solid rgb(229,229,229);
    padding-top: 10px;
    padding-left: 14px;
  }

  p {
    margin:0;
    text-align: center;
    text-transform: uppercase;
    font-size:18px;
    font-family: MuseoSansRounded-1000;
  }

  @media only screen and (min-width: 900px) {
    .container {
      max-width: 100%;
    }
  }
  .completion-question {
    word-wrap: break-word;
  }
  .body {
    // padding-top:20px ;
    // padding-left:24px;
    // padding-right:24px;
    background: white;
  }

  .container {
    padding: 0px 0px 0px 21px;
  }
  .gray--background {
    background-color:  $lighter;
  }

  .publish {
    background: $primary;
    font-family: MuseoSans-900;
    font-size: 16px !important;
    text-align: center;
    padding: 1px;
  }
  @media only screen and (min-width: 600px) {

    .media-section {
      margin-bottom: 28px;
      margin-top: 24px;
      font-size:16px;
    }
  }
  .media-section {
    .btn {
      color: $blue;
    }
  }
  .web-media {

    height: fit-content;
    border-radius: 12px;
    background-color: #ffffff;

    .input-container {
      width:80%;
      max-width:519px;
      margin: auto;
      box-shadow: 0 2px 6px 0.5px $border-color;
      input:focus , textarea:focus {
        outline: none;
      }
      .web-media-text {
        font-size: 10px;
        letter-spacing: normal;
        text-align: left;
        color: #3f3e3f;
      }

    }

  }

  .edit {
    margin-top: auto;
    color: $blue;
    div {
      font-size: 13px;
      font-family: MuseoSans-500;
      color: $blue;
    }
  }
  .mb-24 {
    margin-bottom: 24px;
  }

  .input-container input:focus, .input-container textarea:focus {
    outline: none;
  }

  .input-container textarea {
    width: 100%;
  }

  .upload {
    width: 100%;
    border-radius:28px 28px 28px 28px;
    min-height: 48px;
    box-shadow: 0 2px 6px 0.5px $border-color;
    margin-bottom: 10px;
    background-color: white;
    color: $blue;
  }

  .input-container label, .input-container label{
    color: $blue;
    font-family: MuseoSans-500;
    font-size: 16px;
  }
  .input-container textarea {
    font-size: 16px;
    font-family: MuseoSans-500;
  }

  .image-list {
    position: relative;
    display:inline-block;
    padding:1px;
  }

  .image-list .image-list-button {
    background: $white;
    position: absolute;
    right: 0;
    bottom: 0;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  tr:hover {
    background: unset;
  }

  .no-questions-text {
    text-align: center;
  }

  .secondary-button {
    width: fit-content;
    font-weight: bold;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TaskEdit.vue